<template>
  <DefaultSection class="has-border-bottom">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h2 class="title is-size-4 is-size-3-desktop has-text-weight-bold">
            {{ title }}
          </h2>
          <div
            v-if="teaser"
            class="content has-text-weight-bold"
            v-html="teaser"
          />
        </div>
        <div class="column is-5 is-offset-1">
          <ImageItem
            v-if="image"
            v-bind="image.image"
            :image-style="imageStyleTestimonial"
            class="image image-centered image-shadow"
          />
          <ImageItem
            v-else-if="logo"
            v-bind="logo.image"
            :image-style="imageStyle"
            class="testimonial-logo"
          />
          <div
            v-if="image && image.caption"
            class="mt-4 is-size-6 is-size-7-desktop has-text-centered has-text-weight-semibold image-caption"
          >
            {{ image.caption }}
          </div>
        </div>
        <div class="column is-full has-text-centered-mobile">
          <VuepalLink
            :to="url?.path"
            class="button is-sky-blue has-text-weight-bold has-text-white px-6 mt-4"
          >
            mehr
          </VuepalLink>
        </div>
      </div>
    </div>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { TestimonialDetailsFragment } from '#graphql-operations'

defineProps<TestimonialDetailsFragment>()

const imageStyleTestimonial = defineImageStyle({
  type: 'sizes',
  aspectRatio: 445 / 280,
  sizes: {
    sm: 270,
    md: 445,
  },
})

const imageStyle = defineImageStyle({
  type: 'pictures',
  pictures: {
    xs: {
      width: 300,
    },
    lg: {
      width: 400,
    },
  },
})
</script>

<style scoped lang="scss">
.testimonial-logo {
  ::v-deep(img) {
    margin-top: toRem(50);
    max-height: 120px;
  }
}

.image-centered {
  ::v-deep(img) {
    width: 270px;
    margin: 0 auto;
    @include desktop {
      width: 100%;
    }
  }
}

.testimonial {
  margin-bottom: 5rem;
  padding-bottom: 5rem;
  a {
    color: $primary;
  }

  border-bottom: 1px solid $grey-light;

  &:last-of-type {
    border-bottom: none;
  }
}
</style>
